// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'
import VueSimpleVerify from 'vue-simple-verify'
import '../node_modules/vue-simple-verify/dist/vue-simple-verify.css'
import md5 from 'js-md5';
// import 'font-awesome/css/font-awesome.min.css';
import svgIcon from '@/components/SvgIcon'    // 引入svg组件
//全局注册icon-svg
Vue.component('svg-icon', svgIcon)
import './icons'

Vue.component('vue-simple-verify', VueSimpleVerify)
Vue.use(ElementUI, { locale })
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$md5 = md5;
// 正式环境上下文路径
Vue.prototype.$urlhead = '/sso_server'
Vue.prototype.$basePath = '/sso_web'
Vue.prototype.$publicURL = './static';//vue中导入静态html页面
// 全局加密KEY
Vue.prototype.$key = '!s@z#h$t%1^2&3*4';
// 重写sort
Array.prototype.arrSort = function (type) {
  if (type === 'desc') { return this.sort((a, b) => b - a) } // 箭头函数不加大括号时指向这个函数的返回值，可以不写return关键字
  else { return this.sort((a, b) => a - b) } // 箭头函数不加大括号时指向这个函数的返回值，可以不写return关键字
}

/* eslint-disable no-new */
/* eslint-disable no-new */
let ua = navigator.userAgent.toLocaleLowerCase();
if (ua.match(/msie/) == null && ua.match(/trident/) == null) {
new Vue({
    el: '#app',
    router,
    store: store,
    components: {App},
    template: '<app/>'
  }).$mount('#app');

}
// export default vue



// WEBPACK FOOTER //
// ./src/main.js